export default "__VITE_ASSET__DZtoZwVP__"